import {
  createContext,
  RefObject,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import useMeasureElement from './useMeasureElement'

interface ContextInfo {
  height: number;
  width: number;
  setHeight: (height: number) => void;
  setWidth: (width: number) => void;
}

const TitleBarContext = createContext<ContextInfo>({
  height: 0,
  width: 0,
  setHeight: () => undefined,
  setWidth: () => undefined
})

export default TitleBarContext

const useTitleBarSize = () => {
  const { height, width } = useContext(TitleBarContext)
  return { height, width }
}

const useMeasureTitleBar = (ref: RefObject<HTMLElement>) => {
  const { height, width, setHeight, setWidth } = useContext(TitleBarContext)

  const onMeasure = useCallback((element) => {
    const rect = element.getBoundingClientRect()
    setHeight(rect?.height ?? 0)
    setWidth(rect?.width ?? 0)
  }, [setHeight, setWidth])

  useMeasureElement(ref, onMeasure)

  return { height, width }
}

const useTitleBarInfo = () => {
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)

  return useMemo(
    () => ({
      width,
      height,
      setHeight,
      setWidth
    }),
    [height, width]
  )
}

export { useTitleBarSize, useMeasureTitleBar, useTitleBarInfo }
